import Vue from "vue";
import { ErrorsPlugin } from "../util/errors";

Vue.use(ErrorsPlugin);
